<template>
    <div v-show="mask"  @scroll.prevent @mousewheel.prevent @touchmove.prevent class="mask flex_c_center">
        <div class="content">
            <div class="maskTitle f24 line32 fw600">{{status=='login'?'登录':(status=='regist'?'注册':'修改密码')}}</div>
            <div class="flex_r input margint40">
                <input type="tel" class="flex1" maxlength="11" v-model="phone" placeholder="请输入手机号码" >
            </div>

            

            <div v-if="status=='regist'||status=='reset'" class="flex_r input margint20">
                <input type="tel" class="flex1" maxlength="6" v-model="code" placeholder="请输入验证码">
                <span @click.stop="getCode" class="marginl4 code flex0">{{ isSendCode ? '已发送（'+ sendNum + '）' : '获取验证码'}}</span>
            </div>

            <div class="flex_r input margint20">
                <input type="password" class="flex1" maxlength="16" minlength="6" v-model="password" placeholder="请输入登录密码" >
            </div>

            <div  v-if="status=='regist'||status=='reset'" class="flex_r input margint20">
                <input type="password" class="flex1" maxlength="16" minlength="6" v-model="cpassword" placeholder="请再次输入密码" >
            </div>

            <div class="flex_r_between margint10 themeColor">
                <span>
                    <span @click.stop="changeStatus('login')" class="cursor">登录</span>
                    <span> / </span>
                    <span @click.stop="changeStatus('regist')" class="cursor">注册</span>
                </span>
                <span @click="changeStatus('reset')" class="cursor">忘记密码</span>
            </div>
            <div v-if="status=='login'" @click.stop="login" class="login margint20">登录</div>
            <div  v-if="status=='regist'" @click.stop="confirm"  class="login margint20">确定注册</div>
            <div  v-if="status=='reset'" @click.stop="confirm"  class="login margint20">确定重置</div>
            <div  class="rule flex_r">
                <svgIcon  @click.native.stop="checkin=!checkin" class="check" :name="checkin? 'checkin':'check'" />
                <p @click.self="checkin=!checkin">我已阅读并同意<a href="https://img.jj58.com.cn/FvdXG0IBH1VZ13AQoAblTI7N2_ZF" target="_blank">《用户政策》</a></p>
            </div>
        </div>
        <svgIcon @click.native="mask=!mask"  name='close' class="f36 margint28" />
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
    name: 'login',
    data(){
        return {
            code: '',
            isSendCode: false,
            sendNum: 60,
            phone: '',
            password: '',
            cpassword: '',
            mask: false,
            status: 'login',  //login regist reset
            checkin: false
        }
    },
    methods: {
        ...mapMutations(['setData']),
        canSend(){
            if(this.isSendCode) return
            let timer = setInterval(()=>{
                if(this.sendNum == 1){
                    clearInterval(timer)
                    this.isSendCode = false
                    return
                }
                this.sendNum--
            },1000)
        },
        async getCode(){
            try{
                if(this.isSendCode)return
                if(!this.phone)return this.$alert('请输入手机号')
                if(this.phone.length!=11||this.phone[0]!=1)return this.$alert('请输入正确的手机号')
                this.sendNum = 60;
                this.canSend();
                this.isSendCode=true;
                let data = await this.$http.get(this.$api.getSmsCode+'?phone='+ this.phone);
                if(data.status!=='success') return this.$alert(data.msg)
            }catch(e){
                this.isSendCode = false;
                throw new Error(e)
            }

        },
        changeStatus(status){
            this.status = status;
            this.phone = '';
            this.password = '';
            this.cpassword = '';
            this.code = '';
            this.sendNum = 60;
        },
        async oldlogin(){
            try{
                if(!this.phone)return this.$alert('请输入手机号')
                if(this.phone.length!=11||this.phone[0]!=1)return this.$alert('请输入正确的手机号')
                if(!this.code) return this.$alert('请输入验证码')
                let data = await this.$http.get(`${this.$api.checkCode}?phone=${this.phone}&code=${this.code}`);
                this.setData({
                    key: 'userInfo',
                    val: data.data
                })
                this.$setCookie('cy_uid',data.data.uid,7);
                this.$setCookie('cy_name',data.data.name,7);
                this.$setCookie('cy_logo',data.data.logo,7);
                this.mask = false;
            }catch(e){
                throw new Error(e)
            }
            
        },
        async login(){
            if(!this.checkin) return this.$alert('请阅读用户政策');
            if(!this.phone)return this.$alert('请输入手机号')
            if(this.phone.length!=11||this.phone[0]!=1)return this.$alert('请输入正确的手机号')
            if(!this.password) return this.$alert('请输入登录密码')
            let data = await this.$http.post(this.$api.login,{
                phone: this.phone,
                pwd: this.password
            });
            this.setData({
                key: 'userInfo',
                val: data.data
            })
            this.$setCookie('cy_uid',data.data.uid,7);
            this.$setCookie('cy_name',data.data.name,7);
            this.$setCookie('cy_logo',data.data.logo,7);
            this.mask = false;
            this.phone = '';
            this.password = '';
            this.cpassword = '';
            this.code = '';
            this.sendNum = 60;
        },
        async confirm(){
            try{
                if(!this.checkin) return this.$alert('请阅读用户政策');
                if(!this.phone)return this.$alert('请输入手机号');
                if(this.phone.length!=11||this.phone[0]!=1)return this.$alert('请输入正确的手机号')
                if(!this.code) return this.$alert('请输入验证码')
                if(!this.password) return this.$alert('请输入登录密码')
                if(this.password.length<6||this.password.length>16) return this.$alert('密码长度为6-16位')
                if(!this.cpassword) return this.$alert('请再次输入密码')
                if(this.cpassword!=this.password) return this.$alert('两次密码不一样')
                let obj = await this.$http.get(`${this.$api.checkCodeOnly}?phone=${this.phone}&code=${this.code}`);
                if(this.status=='regist'){
                    if(!this.checkin) return this.$alert('请阅读用户政策');
                    let data = await this.$http.post(this.$api.regis,{
                        phone: this.phone,
                        pwd: this.password
                    })
                    this.setData({
                        key: 'userInfo',
                        val: data.data
                    })
                    this.$message.success(data.msg);
                    this.$setCookie('cy_uid',data.data.uid,7);
                    this.$setCookie('cy_name',data.data.name,7);
                    this.$setCookie('cy_logo',data.data.logo,7);
                    this.mask = false;

                }else if(this.status=='reset'){
                    let data = await this.$http.post(this.$api.editPwd,{
                        phone: this.phone,
                        pwd: this.password
                    })
                    this.setData({
                        key: 'userInfo',
                        val: data.data
                    })
                    this.$message.success(data.msg);
                    this.$setCookie('cy_uid',data.data.uid,7);
                    this.$setCookie('cy_name',data.data.name,7);
                    this.$setCookie('cy_logo',data.data.logo,7);
                    this.mask = false;
                }
                return
            }catch(e){
                throw new Error(e)
            }
        }
    }
}
</script>
<style lang="less" scoped>
.content{
        width: 480px;
        padding: 40px;
        text-align: center;
        box-sizing: border-box;
        background: #FFFFFF;
        border-radius: 8px;
        .input{
            width: 400px;
            height: 56px;
            border-radius: 4px;
            padding: 0 16px;
            font-size: 20px;
            box-sizing: border-box;
            border: 1px solid #958F8F;
            input{
                height: 100%;
            }
            .code{
                color: #AD2729;
            }
        }
        .login{
            width: 400px;
            height: 56px;
            cursor: pointer;
            background: #AD2729;
            border-radius: 4px;
            font: 400 20px/56px normal;
            color: white;
        }
        .themeColor{
            color: #AD2729;
        }
        .rule{
            margin-top: 20px;
            .check{
                font-size: 14px;
                line-height: 22px;
                cursor: pointer;
            }
            p{
                margin-left: 10px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                line-height: 22px;
                color: #958F8F;
                cursor: pointer;
            }
            a{
                font-size: 16px;
                color: #2F74FB;
            }
        }
    }
</style>